import {
    IonLogoCss3,
    MdiLanguageJavascript,
    MdiReact,
    MdiSass,
    // MdiVuejs,
    RiHtml5Fill
} from './icons/language';

const languages = [
    // { name: 'Vue', icon: <MdiVuejs /> },
    { name: 'React', icon: <MdiReact /> },
    { name: 'JS', icon: <MdiLanguageJavascript /> },
    { name: 'Sass', icon: <MdiSass /> },
    { name: 'CSS', icon: <IonLogoCss3 /> },
    { name: 'HTML', icon: <RiHtml5Fill /> },
];

export default languages;
